import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalRJCE = ({ toggleFunction, modalState }) => {
  // const modalTitle = 'Reconocimiento a Jefes de Residentes Año 2025 y Entrega de Carta de Egreso Año 2025'
  const titulo = 'División de Estudios para Graduados de la Facultad de Medicina'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-justify premio-dem'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner mb-4' /> */}

          <h3 className='modal-subtitle continuous mb-4 fs-base lh-base'>{titulo}</h3>

          <div className='info-group custom mb-0'>
            <p className="text-center spaced-md">Maracaibo, 04 de enero de 2026</p>

            <p>En vista de la normalidad presentada en el país y en el estado Zulia, y atendiendo a las declaraciones del ciudadano Gobernador del Estado Zulia, Luis Caldera, y de común acuerdo con el Decano de la Facultad de Medicina, Dr. Sergio Osorio Morales, <b>se reprograma la entrega de las CARTAS DE ACEPTACIÓN DE CARGOS DE RESIDENCIAS DE POSGRADO para el día lunes 05 de enero de 2026, a las 10:00 a. m., en el Edificio Ciencia y Salud.</b></p>

            <p>Se recuerda la obligatoriedad de la entrega de dos (02) carpetas, debidamente preparadas, con los documentos indicados en las publicaciones anteriores.</p>

            <p><b>SE PROGRAMA EL INICIO DEL POSGRADO PARA LOS NUEVOS ESTUDIANTES EL DÍA MIÉRCOLES 07 DE ENERO DE 2026.</b></p>

            <p>A partir del 07 de enero, el funcionamiento de los posgrados a nivel asistencial continuará de forma normal, de acuerdo con las decisiones de los Jefes de Servicio, Coordinadores y miembros de los Comités Académicos.</p>

            <p>Se exhorta a permanecer atentos a las informaciones que se publiquen por las vías regulares y a través de nuestra página web: www.depgfmluz.com</p>

            <p>Atentamente,</p>
          </div>

          <div className='info-group w-100 justify-content-start mb-2'>
            <div className='d-flex flex-column text-start'>
              <span className='fw-bold fs-base'>Dr. Freddy Pachano Arenas</span>
              <span className='fw-bold'>Director de la División de Estudios Para Graduados</span>
              <span className='fw-bold'>Facultad de Medicina</span>
              <span className='fw-bold'>UNIVERSIDAD DEL ZULIA</span>
            </div>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalRJCE }